import { useNavigate } from "react-router-dom";
import { Palette } from "lucide-react";
import { AllianceBanner, AllianceSigil } from "@/lib/cosmetics";
import { btn } from "@/components/Page";

export function CustomizeCTA({ a, isLeader }) {
  const navigate = useNavigate();
  return (
    <section className="border border-amber-900/30 bg-zinc-950 p-5 flex flex-wrap items-center gap-4" data-testid="alliance-customize-cta">
      <div className="flex items-center gap-3">
        {a.banner
          ? <AllianceBanner id={a.banner} className="w-14 h-9 rounded-sm border border-zinc-800" />
          : <div className="w-14 h-9 rounded-sm border border-zinc-800 bg-zinc-900" />}
        {a.sigil
          ? <AllianceSigil id={a.sigil} size={36} />
          : <div className="w-9 h-9 rounded-sm border border-zinc-800 bg-zinc-900" />}
        <div>
          <h3 className="font-cinzel text-amber-300 uppercase tracking-wide text-sm flex items-center gap-2"><Palette size={16} /> Alliance Look</h3>
          <p className="text-xs text-zinc-500">{isLeader ? "Spend treasury gold on banners & sigils to brand your page." : "Your leader can brand the alliance with banners & sigils."}</p>
        </div>
      </div>
      <button data-testid="alliance-customize-btn" onClick={() => navigate("/alliance/customize")} disabled={!isLeader}
        className={btn("primary") + " py-2 px-4 text-sm ml-auto flex items-center gap-1.5 disabled:opacity-40 disabled:cursor-not-allowed"}>
        <Palette size={15} /> Customize
      </button>
    </section>
  );
}
